import { render, staticRenderFns } from "./carOwnerData.vue?vue&type=template&id=316ab00b&"
import script from "./carOwnerData.vue?vue&type=script&lang=js&"
export * from "./carOwnerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "carOwnerData.vue"
export default component.exports